module.exports = __webpack_public_path__ + "img/icon.c24cf2dc.svg";